import React, { useEffect, useRef } from 'react';
import { Cut } from './Cut';

// Auto / 1080p / 720p / 480p / 360p — rendered only when hls.js exposes more than one rung.
export const QualityMenu = ({ quality, open, onToggle, onPick, up = true }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) onToggle(false); };
    document.addEventListener('pointerdown', close);
    return () => document.removeEventListener('pointerdown', close);
  }, [open, onToggle]);

  if (!quality?.levels || quality.levels.length < 2) return null;
  const cur = quality.levels[quality.current];
  const label = quality.auto ? `Auto${cur ? ` · ${cur.height}p` : ''}` : `${cur?.height ?? ''}p`;
  const options = [{ index: -1, label: 'Auto' }, ...[...quality.levels].sort((a, b) => b.height - a.height).map((l) => ({ index: l.index, label: `${l.height}p` }))];

  return (
    <div className="relative" ref={ref} data-testid="film-quality-selector">
      <span className="th-frame th-cut th-cut-sm inline-flex">
        <button type="button" onClick={() => onToggle(!open)} aria-haspopup="listbox" aria-expanded={open}
          className="th-cut th-cut-sm th-solid px-3 h-9 th-label text-[10px] whitespace-nowrap" style={{ color: 'var(--th-accent-soft)' }} data-testid="film-quality-btn">
          {label}
        </button>
      </span>
      {open && (
        <Cut size="sm" glass={false} className={`absolute ${up ? 'bottom-full mb-2' : 'top-full mt-2'} left-0 min-w-[132px] z-50 th-rise`} data-testid="film-quality-menu">
          <ul role="listbox" className="py-1">
            {options.map((o) => {
              const active = o.index === -1 ? quality.auto : (!quality.auto && quality.current === o.index);
              return (
                <li key={o.index}>
                  <button type="button" role="option" aria-selected={active} onClick={() => { onPick(o.index); onToggle(false); }}
                    className="w-full text-left px-4 py-2.5 th-label text-[11px] flex items-center gap-3 hover:bg-[rgba(216,177,125,0.08)]"
                    style={{ color: active ? 'var(--th-accent-soft)' : 'var(--th-muted)' }} data-testid={`film-quality-option-${o.label.toLowerCase()}`}>
                    <span className="w-1 h-1" style={{ background: 'var(--th-accent)', opacity: active ? 1 : 0 }} />
                    {o.label}
                  </button>
                </li>
              );
            })}
          </ul>
        </Cut>
      )}
    </div>
  );
};
